import { useEffect, useState } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(false);

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };

  useEffect(() => {
    const route = window.location.hash.substr(1);
    let element = document.getElementById(route);
    element &&
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
  }, []);

  return (
    <section className='navbar container'>
      <div className='desktop-menu'>
        <a
          href='/'
          aria-current='page'
          className='navbar-logo-wrap w-inline-block w--current'
        >
          <img
            src='/img/logos/new_type_light.svg'
            loading='lazy'
            alt='Lancaster Logo'
            width="120"
            height="50"
          />
        </a>
        <div className='links'>
          {/* <a
            href='/'
            onClick={(e) => {
              e.preventDefault();
              if (window.location.pathname === '/') {
                let element = document.getElementById('about-us');
                element &&
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
              } else {
                window.location.href = '/#about-us';
              }
            }}
          >
            Nosotros
          </a> */}
          <a
            href='/'
            onClick={(e) => {
              e.preventDefault();
              if (window.location.pathname === '/') {
                let element = document.getElementById('how-it-works');
                element &&
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
              } else {
                window.location.href = '/#how-it-works';
              }
            }}
          >
            Como Funciona
          </a>
          
          <a
            href='/'
            onClick={(e) => {
              e.preventDefault();
              if (window.location.pathname === '/') {
                let element = document.getElementById('faq-section');
                element &&
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
              } else {
                window.location.href = '/#faq-section';
              }
            }}
          >
            Preguntas Frecuentes
          </a>
          <a
            href='https://wa.me/528112557887?text=Hola,%20quiero%20saber%20más%20sobre%20Lancaster'
            className='get-started-button'
           >
            Contacto
          </a>
        </div>
      </div>
      <div className='mobile-menu'>
        <img
          className="menu-logo-mobile"
          src='/img/logos/new_type_light.svg'
          loading='lazy'
          alt='Lancaster Logo'
          width="120"
          height="50"
        />
        <div className='mobile-menu-toggle' onClick={toggleMenu}>
          <img
            className='mobile-menu-icon'
            src='/img/menu-burger.svg'
            alt='Menu Icon'
            width="30"
            height="30"
          />
        </div>
        {openMenu && (
          <div className='mobile-links'>
            <a
              href='/'
              onClick={(e) => {
                setOpenMenu(false);
                let element = document.getElementById('about-us');
                e.preventDefault();
                element &&
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
              }}
            >
              Nosotros
            </a>
            <a
              href='/'
              onClick={(e) => {
                setOpenMenu(false);
                e.preventDefault();
                if (window.location.pathname === '/') {
                  let element = document.getElementById('how-it-works');
                  element &&
                    element.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center',
                    });
                }
              }}
            >
              Como Funciona
            </a>
            <a
              href='/'
              onClick={(e) => {
                setOpenMenu(false);
                let element = document.getElementById('traits');
                e.preventDefault();
                element &&
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
              }}
            >
              Preguntas Frecuentes
            </a>
            <a
              href='/'
              className='get-started-button-mobile'
              onClick={(e) => {
                setOpenMenu(false);
                e.preventDefault();
                if (window.location.pathname === '/') {
                  let element = document.getElementById('calculadora');
                  element &&
                    element.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center',
                    });
                } else {
                  window.location.href = '/#ai-pricing';
                }}}
            >
              Precios
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default Navbar;
